import { render } from "./SourcesList.vue?vue&type=template&id=588d26e1"
import script from "./js/sourcesList.js?vue&type=script&lang=js&external"
export * from "./js/sourcesList.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__